import {CUSTOM_RECT_TYPE} from "../../constants/custom-fabric-types";

export function initCustomRectClass(fabric) {
  const instance = fabric.util.createClass(fabric.Rect, {
    type: CUSTOM_RECT_TYPE,
    initialize: function (options) {
      options = options || {};
      options.corners = options.corners || [0, 0, 0, 0];
      options.selectableBordersOnly = options.selectableBordersOnly || false;
      this.set(options);
      this.fromObject = options.fromObject;
    },
    _render: function (ctx) {
      const scaleX = this.scaleX || 1;
      const scaleY = this.scaleY || 1;

      var rx = this.rx ? Math.min(this.rx / scaleX, this.width / 2) : 0;
      var ry = this.ry ? Math.min(this.ry / scaleY, this.height / 2) : 0;

      var w = this.width,
        h = this.height,
        x = -w / 2,
        y = -h / 2,
        // magic number для приближения дуг кривыми Безье
        k = 1 - 0.5522847498;

      ctx.beginPath();
      ctx.moveTo(x + rx * this.corners[0], y);
      ctx.lineTo(x + w - rx * this.corners[3], y);
      this.corners[3] &&
      ctx.bezierCurveTo(
        x + w - k * rx * this.corners[3],
        y,
        x + w,
        y + k * ry * this.corners[3],
        x + w,
        y + ry * this.corners[3]
      );

      ctx.lineTo(x + w, y + h - ry * this.corners[2]);
      this.corners[2] &&
      ctx.bezierCurveTo(
        x + w,
        y + h - k * ry * this.corners[2],
        x + w - k * rx * this.corners[2],
        y + h,
        x + w - rx * this.corners[2],
        y + h
      );

      ctx.lineTo(x + rx * this.corners[1], y + h);
      this.corners[1] &&
      ctx.bezierCurveTo(
        x + k * rx * this.corners[1],
        y + h,
        x,
        y + h - k * ry * this.corners[1],
        x,
        y + h - ry * this.corners[1]
      );

      ctx.lineTo(x, y + ry * this.corners[0]);
      this.corners[0] &&
      ctx.bezierCurveTo(
        x,
        y + k * ry * this.corners[0],
        x + k * rx * this.corners[0],
        y,
        x + rx * this.corners[0],
        y
      );

      ctx.closePath();
      this._renderPaintInOrder(ctx);
    },

    toObject: function() {
      return fabric.util.object.extend(this.callSuper('toObject'), {
        type: CUSTOM_RECT_TYPE,
        corners: this.corners,
        selectableBordersOnly: this.selectableBordersOnly,
        gradient: this.gradient,
        fill: this.fill,
      });
    },
    fromObject: function(object, callback) {
      callback(new fabric.CustomRect(object));
    },
  });

  instance.fromObject = function(object, callback) {
    callback(new fabric.CustomRect(object));
  }

  return instance;
}
